import React from "react";
import {DatePicker, Input, message, Popconfirm, Table} from "antd";
import {ShowProposals} from "./popups/ShowProposals";
import {OldAddUpdateProposal} from "./popups/AddUpdateProposal";
import {pagination} from "../../../controller/Utils";
import {CrmHeaderLinks} from "../CrmHeaderLinks";
import {ProposalList, ProposalPDFGet, ProposalRemove} from "../../../models/crm/proposal";
import {TabStepsProposal} from "./popups/TabStepsProposal";

const {RangePicker} = DatePicker;
const Search = Input.Search;
const moment = require('moment');

export class Proposal extends React.Component {
    state = {
        data: [],
        pagination: pagination,
        value: [],
        loading: false,
        params: {},
        selectedItems: []
    };


    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        let symbol = '';
        if (sorter.order === 'descend')
            symbol = '-';
        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            ordering: `${symbol}${sorter.field}`,
            ...filters,
        });
    };
    fetch = (params = {}) => {
        this.setState({loading: true, params: params});
        ProposalList(params)
            .then(response => {
                const pagination = {...this.state.pagination};
                pagination.total = response.data.count;
                this.setState({
                    loading: false,
                    data: response.data.results,
                    pagination,
                });
            });
    };
    onDateRangeChange = (date, dateString) => {
        this.fetch({
            date_fields: 'created',
            start_date: dateString[0],
            end_date: dateString[1]
        })
    };

    printProposalPDF = (id) => {
        let link = document.createElement('a');
        ProposalPDFGet(id)
            .then(response => {
                link.href = response.data.url;
                link.setAttribute('target', "_blank");
                link.download = `proposal-invoice.pdf`;
                link.click();
            })
    };
    onRowShowClick = (id) => {
        this.setShowProposalModel(true);
        this.setState({showProposalModelData: id})
    };
    onRowUpdateClick = (moderatedProposal) => {
        this.setState({moderatedProposal});
        this.setaddUpdateProposalModel(true, moderatedProposal);
    };

    onDeleteProposal = (id) => {
        ProposalRemove(id)
            .then(() => {
                message.success('Proposal deleted');
                this.fetch()
            })
    };
    columns = [
        {
            title: 'Action',
            render: item => <div className="action-column">
                <a title="View" onClick={() => this.onRowShowClick(item.id)}><i className="fa fa-eye"/></a>
                <a title="Print" onClick={() => this.printProposalPDF(item.id)}><i className="icon-printer"/></a>
                <Popconfirm
                    title="Are you sure delete this Proposal?"
                    onConfirm={() => this.onDeleteProposal(item.id)}
                    okText="Yes"
                    cancelText="No">
                    <a title="Delete"><i className="fa fa-trash-o"/></a>
                </Popconfirm>
            </div>
        }, {
            title: 'Proposal Number',
            dataIndex: 'id',
        }, {
            title: 'Site',
            dataIndex: 'site.label',
        }, {
            title: 'Contact',
            dataIndex: 'contact.label',
        }, {
            title: 'Creation Date',
            dataIndex: 'created',
            render: created => moment(created).format('YYYY-MM-DD')
        },{
            title: 'Service Type',
            dataIndex: 'service_type.label',
        },
    ];

    setaddUpdateProposalModel(addUpdateProposalModel, param) {
        this.setState({addUpdateProposalModel});
        if (param === undefined) {
            this.setState({moderatedProposal: null});
        }
    }

    componentDidMount() {
        this.fetch();
    }

    setShowProposalModel(showProposalModel) {
        this.setState({showProposalModel});
    }

    render() {
        const {pagination, data, loading, row_id} = this.state;

        return <div id="main-content">
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-sm-4 col-12">
                            <h3 className="main-heading">CRM</h3>
                        </div>
                        <div className="col-sm-8 col-12">
                            <CrmHeaderLinks/>
                        </div>
                    </div>
                    <div className="row clearfix edit-header">
                        <div className="col-lg-3 col-sm-4 col-12">
                            <div id="date_range_wrapper">
                                <RangePicker onChange={this.onDateRangeChange}/>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-2 col-2 padding-0 pull-xs-left">
                            <button className="btn submit-btn xs-hide" type="button"
                                    onClick={() => this.setaddUpdateProposalModel(true)}>Create Proposal
                            </button>
                            <button className="btn submit-btn xs-show" type="button"
                                    onClick={() => this.setaddUpdateProposalModel(true)}><i className="fa fa-plus"/>
                            </button>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-10 pull-xs-right proposal-search">
                            <Search placeholder="Input search text" onSearch={value => this.fetch({search: value})}
                                    style={{width: "65%"}}/>
                            {/*<AdvancedSearchProposal/>*/}
                        </div>
                        <div className="col-lg-3 col-sm-12 col-12 edit-div">
                            <span>{pagination.total} Records</span>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-12">
                            <div className="listing-table">
                                <Table
                                    className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                                    pagination={pagination} rowKey={row => row.id} columns={this.columns}
                                    dataSource={data} loading={loading} onChange={this.handleTableChange}
                                    locale={{emptyText: 'No Proposal Available'}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal">
                <TabStepsProposal moderated={this.state.moderatedProposal} visible={this.state.addUpdateProposalModel}
                                  setModelVisible={() => this.setaddUpdateProposalModel(false)}
                                  fetch={() => this.fetch()}/>
            </div>
            <ShowProposals visible={this.state.showProposalModel}
                           setModelVisible={() => this.setShowProposalModel(false)}
                           data={this.state.showProposalModelData}/>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/Proposal.jsx